import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'vector_file_editor' */ './VectorFileEditorPage'),
);
